import { InfoCard, StructuredMetadataTable } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { buildMetadata, formatDate } from './annotations';

export function AccountDetailsCard() {
  const { entity } = useEntity();
  const metadata = buildMetadata(entity, [
    { label: 'Status', key: 'status' },
    { label: 'AWS Account ID', key: 'aws-account-id' },
    { label: 'Account Name', key: 'account-name' },
    { label: 'Email', key: 'email' },
    { label: 'Drift', key: 'drift' },
    { label: 'Last Updated', key: 'last-updated', format: formatDate },
  ]);

  return (
    <InfoCard title="Account Details">
      <StructuredMetadataTable metadata={metadata} />
    </InfoCard>
  );
}
